import { create } from "zustand";
import type { ItemCategory } from "@stocks/shared";

/**
 * 품목 등록 ↔ 입고 화면 사이에서 사진/카테고리를 유지하기 위한 임시 보관소.
 * File 객체는 직렬화할 수 없으므로 메모리(클라이언트 내비게이션 동안)에만 둔다.
 */
type ItemDraftStore = {
  files: File[];
  category: ItemCategory | "";
  spec: string;
  setDraft: (draft: Pick<ItemDraftStore, "files" | "category" | "spec">) => void;
  clearDraft: () => void;
};

export const useItemDraftStore = create<ItemDraftStore>((set) => ({
  files: [],
  category: "",
  spec: "",
  setDraft: (draft) => set(draft),
  clearDraft: () => set({ files: [], category: "", spec: "" }),
}));
